import React, { useState, useEffect, useContext } from "react";
import loaderGif from "../../src/Images/images/loader.gif";
import Nabvar from "./Navbar";
import Footer from "./footer";
import { Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import { MdOutlineDateRange } from "react-icons/md";
import { FaUserTie } from "react-icons/fa";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import Blog from "./Blogs";
import { GlobalContext } from "../Context/GlobalState";
import { BASE_URL_API_TRANX_BLOG } from "../Utils/Constant";
import { basicauthblog } from "../Utils/Credentials";
import { AiOutlineEye } from "react-icons/ai";
const normalizeBlogResponse = (apiData) => {
  if (!apiData) return null;

  const blog = Array.isArray(apiData) ? apiData[0] : apiData;
  if (!blog) return null;

  return {
    id: blog.id || "",
    title: blog.title || "",
    excerpt: blog.excerpt || "",
    image_url: blog.image_url || "",
    image_desc: blog.image_desc || blog.title || "",
    keyword: blog.keyword || "",
    tag: blog.tag || "",
    slug: blog.slug || "",
    in_time: blog.in_time || "",
    views: blog.views || "0",
    author_name: blog.author_name || "Unknown",
    author_slug: blog.author_slug || "",
    author_url: blog.author_url || "",
    category_name: blog.category_name || "",
    sub_category: blog.sub_category || "",

    blocks: Array.isArray(blog.blocks)
      ? blog.blocks
          .sort((a, b) => Number(a.block_order) - Number(b.block_order))
          .filter((b) => b && (b.block_content || b.block_image))
          .map((b) => ({
            block_type: (b.block_type || "p").toLowerCase(),
            block_content: b.block_content || "",
            block_image: b.block_image || "",
            block_image_alt: b.block_image_alt || "",
            block_image_desc: b.block_image_desc || "",
            block_image_title: b.block_image_title || "",
            block_order: b.block_order || 0,
          }))
      : [],
  };
};

const Slug = () => {
  const { password, username } = basicauthblog;
  const base64Credentials =
    typeof window === "undefined"
      ? Buffer.from(`${username}:${password}`).toString("base64")
      : btoa(`${username}:${password}`);
  const [blogData, setBlogData] = useState(null);
  const [postdata, setpostdata] = useState([]);
  const { post_slug } = useParams();
  useEffect(() => {
    console.log(post_slug);
    if (post_slug) {
      GetAuthorsBlog(post_slug);
    }
  }, [post_slug]);

  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const tags = [
    "Business",
    "Corporate",
    "Finance",
    "Invest",
    "Planning",
    "Sport",
    "News",
  ];
  const GetAuthorsBlog = async (slug) => {
    setTransactionLoaderState(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ slug: slug }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANX_BLOG}/GetProductBlogBySlug`,
        requestOptions
      );
      const data = await res.json();
      console.log("Geteditloadblog response:", data);

      if (data.status === "0") {
        const normalized = normalizeBlogResponse(data.data);
        setBlogData(normalized);
      } else {
        console.error("Failed to fetch blogs:", data.msg);
      }
    } catch (error) {
      console.error("Error fetching blog:", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };

  const Getproductblogs = async () => {
    setTransactionLoaderState(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          webid: "2",
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANX_BLOG}/GetAllProductBlog`,
        requestOptions
      );
      const data = await res.json();

      if (data.status === "0") {
        setpostdata(data.data || []);
      } else {
        console.error("Failed to fetch blogs:", data.msg);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };

  useEffect(() => {
    if (blogData) {
      const images = document.querySelectorAll(".blog-content img");
      images.forEach((img) => {
        img.style.borderRadius = "1rem";
        img.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
        img.style.width = "100%";
        img.style.height = "auto";
      });
    }
  }, [blogData]);

  useEffect(() => {
    Getproductblogs();
  }, []);

  if (!blogData) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
        }}
      >
        <img src={loaderGif} alt="Loading..." style={{ height: "60vh" }} />
      </div>
    );
  }
  function cleanBlockContent(htmlString = "") {
    return htmlString
      .replace(/<\/?span[^>]*>/g, "")
      .replace(/ style="[^"]*"/g, "")
      .replace(/&nbsp;/g, " ")
      .replace(/<!--.*?-->/g, "")
      .replace(/<o:p><\/o:p>/g, "")
      .trim();
  }

  const formatBlogDate = (dateString) => {
    const date = new Date(dateString.replace(" ", "T"));

    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  };

  return (
    <>
      <Helmet>
        {/* SEO Meta Tags */}
        <title>{blogData.title}</title>
        <meta name="description" content={blogData.excerpt} />
        <meta name="keywords" content={blogData.keyword} />
        <link
          rel="canonical"
          href={`https://billpunch.com/blog/${post_slug}`}
        />
        {/* Open Graph Meta Tags */}
        <meta property="og:title" content={blogData.title} />
        <meta property="og:description" content={blogData.excerpt} />
        <meta property="og:image" content={blogData.image_url} />
        <meta
          property="og:url"
          content={`https://billpunch.com/blog/${post_slug}`}
        />
        <meta property="og:type" content="article" />

        {/* Twitter Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={blogData.title} />
        <meta name="twitter:description" content={blogData.excerpt} />
        <meta name="twitter:image" content={blogData.image_url} />
        {/* <script type="application/ld+json">{blogData.schema_json}</script> */}
      </Helmet>

      <Nabvar />

      <div className="row mt-4">
        <div className="col-md-1"></div>
        <div className="col-10 m-md-0 m-3">
          <div className="row " style={{ height: "auto" }}>
            <div
              className="col-md-9 col-12 m-0 p-0 "
              style={{
                // height: "120vh",
                overflowY: "auto",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
            >
              <style>
                {`
          .hide-scrollbar::-webkit-scrollbar {
            display: none;
          }
        `}
              </style>
              <div style={{ width: "90%" }}>
                <div className="d-flex flex-wrap"></div>

                <h1>{blogData.title}</h1>

                <div className="row">
                  <p
                    className="col"
                    style={{
                      fontSize: ".9rem",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {blogData.author_url ? (
                      <img
                        src={blogData.author_url}
                        alt={blogData.author_url}
                        style={{
                          width: "24px",
                          height: "24px",
                          borderRadius: "50%",
                          objectFit: "cover",
                          marginRight: "8px",
                        }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.style.display = "none";
                          e.target.nextSibling.style.display = "inline-block";
                        }}
                      />
                    ) : (
                      <FaUserTie
                        style={{
                          fontSize: "1.3rem",
                          color: "grey",
                          marginRight: "8px",
                        }}
                      />
                    )}

                    <FaUserTie
                      style={{
                        fontSize: "1.3rem",
                        color: "grey",
                        marginRight: "8px",
                        display: "none",
                      }}
                    />

                    <Link
                      to={`/author/${blogData.author_slug}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", color: "inherit" }}
                      onClick={() => {
                        localStorage.setItem(
                          "author",
                          JSON.stringify({
                            author_slug: blogData.author_slug,
                            name: blogData.author_name,
                            image: blogData.author_url,
                          })
                        );
                      }}
                    >
                      {blogData.author_name}
                    </Link>
                  </p>

                  <p
                    className="col d-flex justify-content-end align-items-center gap-3 p-0"
                    style={{ fontSize: ".9rem", color: "#6b7280" }}
                  >
                    {/* Date */}
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      <MdOutlineDateRange style={{ fontSize: "1.2rem" }} />
                      {formatBlogDate(blogData.in_time)}
                    </span>

                    {/* Views */}
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      <AiOutlineEye style={{ fontSize: "1.2rem" }} />
                      {blogData.views ?? 0}
                    </span>
                  </p>
                </div>

                <div>
                  <img
                    src={blogData.image_url}
                    alt={blogData.image_desc}
                    title={blogData.image_desc}
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "1rem",
                    }}
                  />
                </div>

                <p className="pt-4" style={{ fontSize: "1rem" }}>
                  {blogData.excerpt}
                </p>

                <div className="blog-content mt-3">
                  <style>
                    {`
    .blog-content a {
      text-decoration: none;
    }

    .blog-content a:hover {
      text-decoration: underline;
    }

    .blog-content blockquote {
      border-left: 4px solid #ccc;
      margin: 1em 0;
      padding: 0.75em 1em;
      background: #f9f9f9;
      font-style: italic;
      color: #555;
    }

    .blog-content blockquote p {
      margin: 0;
    }
  `}
                  </style>

                  {(() => {
                    const renderedContents = new Set();

                    return blogData.blocks?.map((block, index) => {
                      const cleanedContent = cleanBlockContent(
                        block.block_content || ""
                      );

                      const type = block.block_type.toLowerCase();
                      if (type === "h1" && index === 0) {
                        return null;
                      }
                      
                      if ((type === "ul" || type === "ol") && cleanedContent) {
                        const tempDiv = document.createElement("div");
                        tempDiv.innerHTML = cleanedContent;
                        const paragraphs = Array.from(
                          tempDiv.querySelectorAll("p")
                        );
                        paragraphs.forEach((p) =>
                          renderedContents.add(p.innerHTML.trim())
                        );
                      }

                      if (
                        type === "p" &&
                        renderedContents.has(cleanedContent.trim())
                      ) {
                        return null;
                      }

                      const supportedTags = [
                        "h1",
                        "h2",
                        "h3",
                        "h4",
                        "h5",
                        "h6",
                        "p",
                        "ul",
                        "ol",
                        "li",
                        "blockquote",
                        "code",
                        "pre",
                        "div",
                        "span",
                        "strong",
                        "em",
                        "u",
                        "img",
                        "video",
                        "a",
                        "br",
                      ];

                      if (
                        (type === "p" || type.startsWith("h")) &&
                        cleanedContent.includes("<img") &&
                        blogData.blocks[index + 1]?.block_type.toLowerCase() ===
                          "img"
                      ) {
                        const nextImg = blogData.blocks[index + 1].block_image;
                        const match = cleanedContent.match(
                          /<img[^>]+src="([^"]+)"/i
                        );
                        if (match && match[1] === nextImg) return null;
                      }

                      if (type === "img" && block.block_image) {
                        return (
                          <div key={index} className="my-3 text-center">
                            <img
                              src={block.block_image}
                              alt={block.block_image_alt || ""}
                              title={block.block_image_title || ""}
                              className="img-fluid"
                              style={{
                                maxWidth: "100%",
                                height: "auto",
                              }}
                            />
                            {block.block_image_desc && (
                              <p
                                className="mt-2 text-muted"
                                style={{ fontStyle: "" }}
                              >
                                {block.block_image_desc}
                              </p>
                            )}
                          </div>
                        );
                      }
                      // FAQ Rendering
                      if (type === "faq_question") {
                        return (
                          <div
                            key={index}
                            style={{
                              background: "#f3f4f6",
                              padding: "12px 16px",
                              borderRadius: "8px",
                              marginTop: "16px",
                              fontWeight: "600",
                              borderLeft: "4px solid #6366f1",
                            }}
                          >
                            Q. {cleanedContent}
                          </div>
                        );
                      }

                      if (type === "faq_answer") {
                        return (
                          <div
                            key={index}
                            style={{
                              background: "#ffffff",
                              padding: "12px 16px",
                              borderRadius: "8px",
                              marginBottom: "12px",
                              borderLeft: "4px solid #22c55e",
                              boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                            }}
                          >
                            <strong>A.</strong> {cleanedContent}
                          </div>
                        );
                      }

                      if (supportedTags.includes(type)) {
                        return (
                          <div
                            key={index}
                            dangerouslySetInnerHTML={{
                              __html: `<${type}>${cleanedContent}</${type}>`,
                            }}
                          />
                        );
                      }

                      return (
                        <p
                          key={index}
                          dangerouslySetInnerHTML={{
                            __html: cleanedContent,
                          }}
                        />
                      );
                    });
                  })()}
                </div>

                <div className="mb-2">
                  {[
                    ...(blogData.keyword || "").split(","),
                    // ...(blogData.tag || "").split(","),
                  ].map(
                    (keyword, index) =>
                      keyword.trim() && (
                        <span
                          key={index}
                          className="me-2 mb-2 d-inline-block"
                          style={{
                            backgroundColor: "#f0f0f0",
                            border: "1px solid #b0b0b0",
                            color: "#333",
                            borderRadius: ".2rem",
                            fontSize: ".8rem",
                            padding: "0.25rem 0.5rem",
                            marginLeft: ".4rem",
                          }}
                        >
                          {keyword.trim()}
                        </span>
                      )
                  )}
                </div>
                <div className="mb-4 px-2">
                  {(blogData.tag || "")
                    .split(",")
                    .filter((tag) => tag.trim())
                    .map((tag, index) => (
                      <a
                        key={index}
                        href={`https://www.google.com/search?q=${encodeURIComponent(
                          tag.trim()
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="me-2 mb d-inline-block text-decoration-none px-2"
                      >
                        #{tag.trim()}
                      </a>
                    ))}
                </div>
              </div>
            </div>
            <div className="col-md-3 col-12 p-4">
              <h6 style={{ fontWeight: "700", marginBottom: "18px" }}>
                Related Reads
              </h6>

              {postdata
                    .slice(-16)
                    .reverse()
                    .map((blog) => (
                <a
                key={blog.id}
                href={`/blog/${blog.slug}`}
                style={{ textDecoration: "none" }}
              >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      gap: "10px",
                      marginBottom: "20px",
                      position: "relative",
                    }}
                  >
                    {/* Left side: Timeline + Text */}
                    <div style={{ display: "flex", gap: "10px", flex: 1 }}>
                      {/* Timeline */}
                      <div
                        style={{
                          position: "relative",
                          paddingLeft: "16px",
                          borderLeft: "2px solid #e5e7eb",
                        }}
                      >
                        <span
                          style={{
                            position: "absolute",
                            left: "-6px",
                            top: "8px",
                            width: "10px",
                            height: "10px",
                            borderRadius: "50%",
                            background: "#111",
                          }}
                        />
                      </div>

                      {/* Text */}
                      <div>
                        <p
                          style={{
                            fontSize: ".85rem",
                            fontWeight: "600",
                            color: "#111",
                            marginBottom: "4px",
                            lineHeight: "1.3",
                          }}
                        >
                          {blog.title}
                        </p>

                        <span
                          style={{
                            fontSize: ".75rem",
                            color: "#777",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          ✍ {blog.author_name}
                        </span>
                      </div>
                    </div>

                    <img
                      src={blog.image_url}
                      alt={blog.image_alt || "Blog"}
                      style={{
                        width: "72px", // ⬅ increased
                        height: "72px", // ⬅ increased
                        objectFit: "cover",
                        borderRadius: "12px", // ⬅ softer, modern
                        flexShrink: 0,
                      }}
                    />
                  </div>
                </a>
              ))}
            </div>
          </div>
          {/* <Blog/> */}
        </div>
        <div className="col-md-1"></div>
      </div>
      <Footer />
    </>
  );
};

export default Slug;
